<template>
  <div class="super-admin-dashboard px-4">
    <h2 class="my-2">Minimart Dashboard</h2>
    <v-row>
      <v-col cols="12">
        <ChartAdminMonthSales />
      </v-col>
      <v-col cols="12">
        <SendGridContactExportBtn />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import SendGridContactExportBtn from '@/components/SendGridContactExportBtn'
import ChartAdminMonthSales from '@/components/ChartAdminMonthSales'
export default {
  name: 'SuperAdminDashboard',
  components: {
    ChartAdminMonthSales,
    SendGridContactExportBtn,
  },
  props: {
    chartId: {
      type: String,
      default: 'line-chart',
    },
  },
  data() {
    return {}
  },
  computed: {
    ...mapGetters('shop', ['getShopTitle']),
  },
}
</script>
